
import imgHamburguesa1 from './asses/not-found/mac-baccon-removebg-preview.png'

import imgHamburguesa2 from './asses/not-found/TripleHamburguesaConQueso-removebg-preview.png'

import imgHamburguesa3 from './asses/not-found/DobleHamburguesaConQueso-removebg-preview.png'

import imgHamburguesa4 from './asses/not-found/doble-macnifica-removebg-preview.png'

import imgHamburguesa5 from './asses/not-found/hamburguesa-removebg-preview.png'

import imgHamburguesa6 from './asses/not-found/macFiestaJr-removebg-preview.png'

import imgHamburguesa7 from './asses/not-found/CuartodeLibraconQueso-removebg-preview.png'

import imgHamburguesa8 from './asses/not-found/BigMac-removebg-preview.png'

import imgDessert1 from './asses/desserts/not-found/BackedApplePie-removebg-preview.png'

import imgDessert2 from './asses/desserts/not-found/ChocolateShake-removebg-preview.png'

import imgDessert3 from './asses/desserts/not-found/VainillaChake-removebg-preview.png'

import imgDessert4 from './asses/desserts/not-found/mcFlurrry-removebg-preview.png'

import imgDessert5 from './asses/desserts/not-found/VainillaCone-removebg-preview.png'

import imgDrink1 from './asses/drinks/not-found/cocacola-removebg-preview.png'

import imgDrink2 from './asses/drinks/not-found/dietcoke-removebg-preview.png'

import imgDrink3 from './asses/drinks/not-found/drpepper-removebg-preview.png'

import imgDrink4 from './asses/drinks/not-found/fantaorange-removebg-preview.png'

import imgDrink5 from './asses/drinks/not-found/sprite-removebg-preview.png'



export const hamburguesasSignature = [
    {name: "Club House Con Carne", kcal: 854, ingredients: "Doble carne de res, tocineta,  chedar",  imagen: ""},
    
    {name: "Club House Pollo Crispis", kcal: 775, ingredients: "Doble carne de res, tocineta, queso chedar",  imagen: ""},
    
    {name: "Crispy Onion BBQ", kcal: 670, ingredients: "Doble carne de pollp, tocineta, queso chedar",  imagen: ""},
    

]



export const tables = ["1", "2", "3", "4", "5", "6", "7", "8", "9"]


export const passwords = [
  "12","34"
 ]

export const hamburguesas = [
    {name: "Bacon", kcal: 454, ingredients: "Doble carne de res, tocineta, queso chedar",  imagen: imgHamburguesa1, price: 20 , date: ""},
    {name: "Triple Hamburguesa", kcal: 547, ingredients: "Doble carne de res y Doble queso chedar", imagen: imgHamburguesa2, price: 25, date: ""},
    {name: "Doble Hamburguesa ", kcal: 445, ingredients: "Doble Carne, Doble queso y Pepinillos", imagen: imgHamburguesa3, price: 18, date: ""},
    {name: "Doble cnifica", kcal: 747, ingredients: "Doble carne de res, Cebolla y lechuga", imagen: imgHamburguesa4, price: 18, date: ""},
    {name: "Hamburguesa", kcal: 266, ingredients: "Carne de res y pepinillos", imagen: imgHamburguesa5, price: 10, date: ""},
    {name: "Fiesta JR", kcal: 265, ingredients: "Hamburguesa con carne de res", imagen: imgHamburguesa6, price: 10, date: ""},
    {name: "Cuarto de libra", kcal: 549, ingredients: "Hamburguesa con cuarto de libra", imagen: imgHamburguesa7, price: 10, date: ""},
    {name: "Big ", kcal: 524, ingredients: "Hamburguesa con salsa especial", imagen: imgHamburguesa8, price: 15, date: ""}
  
  ]

  export const burgers = [
    {name: "Bacon", kcal: 454, ingredients: "Double beef patty, bacon, cheddar cheese", imagen: imgHamburguesa1, price: 20, date: ""},
    {name: "Triple Burger", kcal: 547, ingredients: "Double beef patty and double cheddar cheese", imagen: imgHamburguesa2, price: 25, date: ""},
    {name: "Double Burger", kcal: 445, ingredients: "Double patty, double cheese, and pickles", imagen: imgHamburguesa3, price: 18, date: ""},
    {name: "Double CNIFICA", kcal: 747, ingredients: "Double beef patty, onion, and lettuce", imagen: imgHamburguesa4, price: 18, date: ""},
    {name: "Burger", kcal: 266, ingredients: "Beef patty and pickles", imagen: imgHamburguesa5, price: 10, date: ""},
    {name: "Fiesta JR", kcal: 265, ingredients: "Burger with beef patty", imagen: imgHamburguesa6, price: 10, date: ""},
    {name: "Quarter Pounder", kcal: 549, ingredients: "Burger with quarter pound patty", imagen: imgHamburguesa7, price: 10, date: ""},
    {name: "Big", kcal: 524, ingredients: "Burger with special sauce", imagen: imgHamburguesa8, price: 15, date: ""}
]

  export const desserts = [
    {name: "Backed Apple Pie", kcal: 454, ingredients: "Pie de manzana",  imagen: imgDessert1, price: 10, date: ""},
    {name: "Chocolate Chake", kcal: 547, ingredients: "Chake de Chocolate", imagen: imgDessert2, price: 10, date: ""},
    {name: "Vainilla Chake ", kcal: 445, ingredients: "Vainilla Chake", imagen: imgDessert3, price: 18, date: ""},
    {name: "Flurry", kcal: 747, ingredients: "Postre Especial ", imagen: imgDessert4, price: 18, date: ""},
    {name: "Vainilla Cone", kcal: 266, ingredients: "Cono de vainilla", imagen: imgDessert5, price: 10, date: ""},
  ]

  export const dessertsEnglish = [
    {name: "Baked Apple Pie", kcal: 454, ingredients: "Apple pie", imagen: imgDessert1, price: 10, date: ""},
    {name: "Chocolate Shake", kcal: 547, ingredients: "Chocolate shake", imagen: imgDessert2, price: 10, date: ""},
    {name: "Vanilla Shake", kcal: 445, ingredients: "Vanilla shake", imagen: imgDessert3, price: 18, date: ""},
    {name: "Flurry", kcal: 747, ingredients: "Special  dessert", imagen: imgDessert4, price: 18, date: ""},
    {name: "Vanilla Cone", kcal: 266, ingredients: "Vanilla cone", imagen: imgDessert5, price: 10, date: ""}
]

  export const drinks = [
    {name: "CocaCola", kcal: 454, ingredients: "Cocacola",  imagen: imgDrink1, price: 5, date: ""},
    {name: "Diet Coke", kcal: 547, ingredients: "Diet Coke", imagen: imgDrink2, price: 6, date: ""},
    {name: "DrPepper", kcal: 445, ingredients: "Dr Pepper", imagen: imgDrink3, price: 5, date: ""},
    {name: "Fanta Orange", kcal: 747, ingredients: "Fanta Orange", imagen: imgDrink4, price: 3, date: ""},
    {name: "Sprite", kcal: 266, ingredients: "Sprite", imagen: imgDrink5, price: 4, date: ""},
   
  ]
